// extracted by mini-css-extract-plugin
module.exports = {"cardStyles":"ChatUi_cardStyles__3ephI","chatDiv":"ChatUi_chatDiv__1ciFu","messagesHeading":"ChatUi_messagesHeading__NTVye","messageParentDiv":"ChatUi_messageParentDiv__1rc4q"};